<style>

img{
  object-fit: cover;
  width: 100%;
}
.body{
  margin: 0 10px;
}

.name{
  font-size: 21px;
  margin: 10px 0;
}
.stars{
  margin: 10px 0;
}
.description{
  margin: 10px 0;
}

.pics{
  display: grid;
  grid-template-columns: 33% 33% 33%;
}
.pic1{
  grid-column: 1;
  margin-right: 5px;
}
.pic2{
  grid-column: 2;
  margin-right: 5px;
}
.pic3{
  grid-column: 3;
}

.info-boxes{
  margin: 20px 0;
}

.card{
  position: relative;
  color: white;
}
.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.8);
}
.info{
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.8);
}
</style>

<Header 
back="{true}"
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }, ] }"
on:addEvent="{ () => push('/create-new-event') }"
on:back="{ () => { pop() } }">Business Profile</Header>
<div class="has-header"></div>

<img src="{item.img}" alt="" class="img">

<div class="body">
  <div class="name">{item.name}</div>
  <div class="stars"><Stars stars="{item.stars}" reviews="260" text=""></Stars></div>
  
  <div class="description">
    Hello, and welcome to The Grove! We are located in the beautiful and busy downtown area of old Bikini Bottom. We're known for our live music, karaoke nights, cocktail nights, and for having too much fun! Come on in for a delicious Margarita, a quick bite to eat, or one of our many events we host!
  </div>

  <h3>Photos</h3>
  
  <div class="pics">
    <div class="pic1"><img src="{item.pics[0]}"></div>
    <div class="pic2"><img src="{item.pics[1]}"></div>
    <div class="pic3"><img src="{item.pics[2]}"></div>
  </div>
  
  <div class="info-boxes">
    <InfoBox icon="phone">213-000-0000</InfoBox>
    <InfoBox icon="address">1234 Main St<br>Los Angeles, CA 90000</InfoBox>
    <InfoBox icon="website">thegrovela.com</InfoBox>
  </div>
  
  <h3>Upcoming Events</h3>
  {#each item.upcoming as i}
    <div class="card" on:click="{ () => { push('/events-info/'+i.oid) } }">
      <img src="{i.img}" alt="" class="img">
      <div class="starts-in"><StartsIn currentTime="{currentTime}" startsAt="{i.startsAt}" endsAt="{i.endsAt}"></StartsIn></div>
      <div class="info">
        <div class="name">{i.name}</div>
        <div><EventTime startsAt="{i.startsAt}" endsAt="{i.endsAt}"></EventTime></div>
      </div>
    </div>
  {/each}
  
</div>

<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';
export let params = {};

import Header from "../components/Header.svelte";
import InfoBox from "../components/InfoBox.svelte";
import ActionBar from "../components/ActionBar.svelte";
import Stars from "../components/Stars.svelte";
import EventTime from "../components/EventTime.svelte";
import StartsIn from "../components/StartsIn.svelte";

let interval = null;
let currentTime =  Math.round( Date.now() / 1000 );
import { onMount } from "svelte";
onMount(async () => {
  // update the event times every X minutes
  interval = setInterval( () => { currentTime =  Math.round( Date.now() / 1000 ) }, 1000 * 60 * 1);
});

let date = Math.round( Date.now() / 1000 );

let item = {
  oid: "123", 
  name: "The Grove Restaurant and Bar", 
  stars: 4.5, 
  img: "/i/the-grove-la.jpg", 
  pics: ["/i/the-grove-la-1.jpg", "/i/the-grove-la-2.jpg", "/i/the-grove-la-3.jpg"],
  upcoming: [
    {
      oid: "abc01def", name: "Cocktail Night At The Grove - $5 Cover", startsAt: date + 120, endsAt: date + 180, img: "/i/event1.jpg"
    }
  ]
};

</script>